<dgx-kpi-list
  [kpis]="kpis"
  [kpisLoading]="loadingKpis"
  [kpiPlaceholder]="placeholders"
  [kpiClass]="itemClass"
></dgx-kpi-list>
